import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const roleHome = (role) =>
  ({ merchant: "/merchant", courier: "/courier", admin: "/admin", customer: "/app" }[role] || "/app");

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sid = params.get("session_id");
    const role = localStorage.getItem("drivons_signup_role") || "customer";
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid, role });
        if (data.token) localStorage.setItem("drivons_token", data.token);
        localStorage.removeItem("drivons_signup_role");
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(roleHome(data.user.role), { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white">
      <div className="text-center space-y-3">
        <div className="w-10 h-10 border-2 border-brand border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-slate-400">Signing you in…</p>
      </div>
    </div>
  );
}
